
import React from 'react';

import styles from './styles.module.scss'
import eventGTM from '../../lib/gtag';

interface ITheGreatSelector {
  options: string[];
  selected: string;
  setSelected(selected: string): void;
}

export default function TheGreatSelector({ options, selected, setSelected }: ITheGreatSelector) {
  if (options.length !== 2) return null;

  return (
    <div className={styles.theGreatSelector}>
      <div className={styles.optionHolder}>
        <div 
          className={`${styles.option} ${selected === options[0] && styles.selected}`} 
          onClick={() => {
            setSelected(options[0])
            eventGTM('clickedOnReduceYourFleets')
          }}
        >
          <div className={styles.radioButtonHolder}>
            <div className={`${styles.radioButton} ${selected === options[0] ? styles.checked : ""}`}>
              <div className={styles.innerCircle}>
                &nbsp;
              </div>
            </div>
          </div>

          <div className={styles.optionContent}>
            <p className={styles.numberText}>1</p>
            <p className={`${styles.optionText} perfect-header`}>{ options[0] }</p>
          </div>
        </div>
      </div>

      <div className={styles.optionHolder}>
        <div 
          className={`${styles.option} ${selected === options[1] && styles.selected}`}
          onClick={() => {
            setSelected(options[1])
            eventGTM('clickedOnManageCosts')
          }}
        >
          <div className={styles.radioButtonHolder}>
            <div className={`${styles.radioButton} ${selected === options[1] ? styles.checked : ""}`}>
              <div className={styles.innerCircle}>
                &nbsp;
              </div>
            </div>
          </div>

          <div className={styles.optionContent}>
            <p className={styles.numberText}>2</p>
            <p className={`${styles.optionText} perfect-header`}>{ options[1] }</p>
          </div>
        </div>
      </div>
    </div>
  )
};
